import { render, staticRenderFns } from "./Taggle.vue?vue&type=template&id=24a3f2a2&scoped=true&"
import script from "./Taggle.vue?vue&type=script&lang=js&"
export * from "./Taggle.vue?vue&type=script&lang=js&"
import style0 from "./Taggle.vue?vue&type=style&index=0&id=24a3f2a2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24a3f2a2",
  null
  
)

export default component.exports